import React from "react";
import { usePage } from "@inertiajs/react";
import useTranslation from "@hooks/use_translation";
import TaskCard from "./TaskCard";
import type { Task } from "@/types/task";

interface TaskCardProps {
  task: Task;
  statusText: string;
}

const SetupWorkPreference: React.FC<TaskCardProps> = ({ task, statusText }) => {
  const { t } = useTranslation("tasks");
  const { uploadResumeA } = usePage<{ uploadResumeA?: boolean }>().props;

  let description;
  let actionText;
  if (uploadResumeA) {
    description = t("workPreferences.descriptionUploadResumeA");
    actionText = t("workPreferences.completeProfileUploadResumeA");
  } else {
    description = t("workPreferences.description");
    actionText = t("workPreferences.completeProfile");
  }

  return (
    <TaskCard
      statusText={statusText}
      task={task}
      title={t("workPreferences.title")}
      description={description}
      actionHref="/work_preferences"
      actionText={actionText}
      externalLink={false}
    />
  );
};

export default SetupWorkPreference;
